module.exports = __webpack_public_path__ + "assets/images/710bb37f57cf3fa0b004bee5333af81a.svg";